/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apicontestassignment",
            "endpoint": "https://bd8j4q8wrh.execute-api.us-east-1.amazonaws.com/upgrade",
            "region": "us-east-1"
        },
        {
            "name": "apicontestupgrade",
            "endpoint": "https://te9t5bb2j4.execute-api.us-east-1.amazonaws.com/upgrade",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:292557b0-dd2b-4b26-a352-a157edb3c8e6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vJsnHnOOk",
    "aws_user_pools_web_client_id": "1pepr3ep78si2d7gqve8pqq875",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "contestsso",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
